import { render } from "./gsrsu0301010501.vue?vue&type=template&id=0f28b1e8&scoped=true"
import script from "./gsrsu0301010501.vue?vue&type=script&lang=js"
export * from "./gsrsu0301010501.vue?vue&type=script&lang=js"

import "./gsrsu0301010501.vue?vue&type=style&index=0&id=0f28b1e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f28b1e8"]])

export default __exports__